import React from 'react';
import './index.less';

import PayoutHead from './components/payout-head';
import PayoutBody from './components/payout-body';

import shouldBeShownToPayColumn from './helpers/should-be-shown-to-pay-column';

function PayoutTable({ rows, sorting, sort, actions, payoutSystem }) {
	const isToPayColumnShouldBeShown = shouldBeShownToPayColumn(payoutSystem, rows);

	return (
		<table className='payout-table new-table'>
			<PayoutHead
				sorting={sorting}
				sort={sort}
				payoutSystem={payoutSystem}
				isToPayColumnShouldBeShown={isToPayColumnShouldBeShown}
			/>
			<PayoutBody
				rows={rows}
				actions={actions}
				payoutSystem={payoutSystem}
				isToPayColumnShouldBeShown={isToPayColumnShouldBeShown}
			/>
		</table>
	);
}

export default PayoutTable;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/payouts/components/table/index.js